import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Tooltip,
  CircularProgress,
} from '@mui/material';

/**
 * PredictionMetadata component displays basic metadata for a model's predictions.
 *
 * Props:
 * - metadata: object containing prediction summary and time range
 * - latency: object containing median latency info
 * - loading: boolean indicating if data is being fetched
 */
function PredictionMetadata({ metadata, latency, loading }) {
  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      {/* Panel title */}
      <Typography variant='h6'>Prediction Metadata</Typography>

      {loading ? (
        // Loader shown while fetching metadata
        <Box display='flex' justifyContent='center' py={3}>
          <CircularProgress size={28} />
        </Box>
      ) : (
        <>
          {/* Render metadata if available */}
          {metadata ? (
            <>
              {/* Total number of predictions */}
              <Typography>
                Total Predictions: {metadata.total_count ?? 0}
              </Typography>

              {/* Time range of predictions */}
              <Typography>
                Time Range: {metadata.time_range?.start ?? 'N/A'} -{' '}
                {metadata.time_range?.end ?? 'N/A'}
              </Typography>

              {/* Class distribution summary */}
              <Typography>
                Class 0: {metadata.predictions_summary?.class_0 ?? 0}, Class 1:{' '}
                {metadata.predictions_summary?.class_1 ?? 0}
              </Typography>

              {/* Threshold used for binary classification */}
              <Tooltip title='Threshold used for classifying predictions'>
                <Typography>
                  Threshold: {metadata.threshold ?? 'N/A'}
                </Typography>
              </Tooltip>

              {/* Median latency if available */}
              {metadata?.median_latency != null && (
                <Tooltip title='Median latency of model predictions in milliseconds'>
                  <Typography>
                    Median Latency: {metadata.median_latency} ms
                  </Typography>
                </Tooltip>
              )}
            </>
          ) : (
            // Fallback message if metadata is null but not loading
            <Typography>No Metadata Available</Typography>
          )}
        </>
      )}
    </Paper>
  );
}

export default PredictionMetadata;
